import React from 'react'
import { reactular } from '@vendhq/reactular'
import {
  AddProductFast,
  InitialQuickProduct,
  ProductType,
  VariantAttribute,
  VariantAttributeCombinationDetail,
} from '@vend/business-components'

interface Props {
  onClose: () => void
  onBack?: () => void
  initialProduct: InitialQuickProduct
  productTypes: ProductType[]
  existingVariantAttributes?: VariantAttribute[]
  existingVariantCombinationDetails?: VariantAttributeCombinationDetail[]
}

export const AddProductFastModal: React.FC<Props> = ({
  onClose,
  onBack,
  initialProduct,
  productTypes,
  existingVariantAttributes,
  existingVariantCombinationDetails,
}) => (
  <AddProductFast
    onClose={onClose}
    onBack={onBack}
    initialProduct={initialProduct}
    types={productTypes}
    existingVariantAttributes={existingVariantAttributes}
    existingVariantCombinationDetails={existingVariantCombinationDetails}
    redirectToEap={false}
    sourcePage="Webregister"
  />
)

export const AddProductFastModalComponent = reactular(
  AddProductFastModal,
  [
    'onClose',
    'initialProduct',
    'productTypes',
    'existingVariantAttributes',
    'existingVariantCombinationDetails',
    'onBack',
  ],
  'reactWrapper'
)
